import React, { Suspense } from 'react';
import { Card } from '../components/Card/Card';
import { Icon } from '../components/Icon/Icon';
import ErrorBoundary from '../pages/ErrorBoundary/ErrorBoundary';

export function withSuspendedCard<T extends {}>(
  Component: React.ComponentType<T>,
  { loadingTitle, loadingHeight }: { loadingTitle?: string; loadingHeight?: number } = {}
): React.ComponentType<T> {
  return function (props: T): JSX.Element {
    return (
      <ErrorBoundary>
        <Suspense
          fallback={<Card height={loadingHeight} title={loadingTitle} actions={<Icon name="edit" loading />} />}
        >
          <Component {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  };
}
